import React from 'react';
import { withNamespaces } from 'react-i18next';
import T from 'prop-types';

import { get } from 'lodash';
import { load as loadTerms } from 'resources/terms';
import { loadRegion } from 'resources/countries';
import { OPENING_HOUR, CLOSED_HOUR, getCountryZone } from 'constants/operating';

import menus from './enData';

import View from './View';

class FooterNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menus,
      operating: {
        opening: OPENING_HOUR.tz('SG').format('hh:mm a'),
        closed: CLOSED_HOUR.tz('SG').format('hh:mm a'),
      },
    };
  }

  async componentDidMount() {
    const [data, region] = await Promise.all([loadTerms({ all: true }), loadRegion()]);
    const terms = data.terms || [];
    const legals = menus.filter(item => item.group === 'legalAndPrivacy')[0];

    terms.forEach(term => {
      const links = get(legals, 'links', []);
      const item = links.filter(link => link.type === term.type)[0];
      if (item) {
        item.href = term.url;
        item.fromApi = true;
      }
    });
    const { country, zone } = getCountryZone(region);

    this.setState({
      menus,
      // convert Operating hours based on timezone
      operating: {
        opening: OPENING_HOUR.tz(country).format('hh:mm a'),
        closed: CLOSED_HOUR.tz(country).format('hh:mm a'),
        zone,
      },
    });
  }

  render() {
    return (
      <View {...this.props} data={this.state.menus} operating={this.state.operating} />
    );
  }
}

FooterNavigation.propTypes = {
  data: T.arrayOf(T.shape({})),
};

export default withNamespaces('core')(FooterNavigation);



// WEBPACK FOOTER //
// ../src/components/Footer/Navigation/index.jsx